export default __webpack_public_path__ + "static/media/results.7ac85d27.svg";